export class ProcessingError extends Error {
    constructor() {
        super('There was an error processing your payment. \n Please try again later.');
    }
}